import { Directive, HostListener, ElementRef, OnInit, HostBinding, Input } from "@angular/core";
import { CultureService } from "@tymes4-shared";

@Directive({
    selector: "[currencyformat]",
    standalone: false
})
export class CurrencyFormatterDirective implements OnInit {

  @Input() currencyformat: number | string = 2;
  @Input() displayCurrencyCode: boolean = true;

  private el: HTMLInputElement;

  constructor(
    private elementRef: ElementRef,
    private cultureService: CultureService
  ) {
    this.el = this.elementRef.nativeElement;
    // Currency formatting requires type="text" not type="number"
    if (this.el.type === 'number') {
      this.el.type = 'text';
    }
  }

  get fractionSize(): number {
    return typeof this.currencyformat === 'number' ? this.currencyformat : parseInt(this.currencyformat) || 2;
  }

  ngOnInit() {
    if (this.el.value) {
      this.el.value = this.formatValue(this.el.value);
    }
  }

  @HostListener("focus", ["$event.target.value"])
  onFocus(value) {
    this.el.value = this.cultureService.parseCurrency(value);
  }

  @HostListener("blur", ["$event.target.value"])
  onBlur(value) {
    this.el.value = this.formatValue(value);
  }

  private formatValue(value: any): string {
    if (this.displayCurrencyCode) {
      return this.cultureService.formatCurrency(value);
    } else {
      return this.cultureService.formatNumber(value, this.fractionSize);
    }
  }
}
